import FarmMapHandler from 'System/Farm/Handler/FarmMapHandler';
import BaseUISystem from './BaseUISystem';
import { FarmHUDHandler } from './HUD/FarmHUDHandler';
import { ShopPopup } from './Menu/ShopPopup/ShopPopup';
import FarmCatalogueMenuHandler from 'System/UI/Menu/FarmCatalogueMenuHandler';
import AreaUnlockPopup from 'System/Farm/Handler/AreaUnlockPopup';
import FarmSharePopup from './Menu/FarmPopup/FarmSharePopup';
import FarmMiniGameMenuHandler from './Menu/FarmMiniGameMenuHandler';
import NoCoinsMenuHandler from './NotImplemented/NoCoinsMenuHandler';
import InfoMenuHandler from "System/UI/Menu/InfoMenuHandler";


export default class FarmUISystem extends BaseUISystem {
    public hud: FarmHUDHandler;
    public map: FarmMapHandler;

    public init(): void {
        this.hud = new FarmHUDHandler({ system: this });
        this.map = new FarmMapHandler({ system: this });

        this.handlers = [
            this.map,
            this.hud,
            new AreaUnlockPopup(this),
            new ShopPopup(this),
            new FarmSharePopup(this),
            new FarmCatalogueMenuHandler({ system: this }),
            new FarmMiniGameMenuHandler({ system: this }),
            new InfoMenuHandler(this),
            new NoCoinsMenuHandler(this),
        ];
    }
}
